import React from 'react';
import classnames from 'classnames';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import s from './LayoutRadioButton.scss';
var LayoutRadioButton = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, Icon = _a.icon, _b = _a.checked, checked = _b === void 0 ? false : _b;
    return (React.createElement(RadioButton, { name: "layout", value: value, onChange: onChange, checked: checked, className: classnames(s['root'], checked && s['checked']), inputClassName: s['input'], size: "small", withMargins: true },
        React.createElement(Icon, { className: s['icon'], disableDefaultColors: true }),
        React.createElement("span", { className: s['label'] }, label)));
};
export default LayoutRadioButton;
//# sourceMappingURL=LayoutRadioButton.js.map